import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Rss = createReactComponent("Rss", ["svg", defaultAttributes, [["path", {
  d: "M4 11a9 9 0 019 9",
  key: "x1s85k"
}], ["path", {
  d: "M4 4a16 16 0 0116 16",
  key: "5pd258"
}], ["circle", {
  cx: "5",
  cy: "19",
  r: "1",
  key: "o81s3p"
}]]]);
export default Rss;